import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { useReducer, useEffect } from 'react';
import useBrowserIdle from "./useBrowserIdle";
import useInterval from "./useInterval";
var PaginationState = /*#__PURE__*/function (PaginationState) {
  PaginationState[PaginationState["Auto"] = 0] = "Auto";
  PaginationState[PaginationState["Idle"] = 1] = "Idle";
  return PaginationState;
}(PaginationState || {});
var Event = /*#__PURE__*/function (Event) {
  Event[Event["Auto"] = 0] = "Auto";
  Event[Event["Next"] = 1] = "Next";
  Event[Event["Prev"] = 2] = "Prev";
  Event[Event["ForcePage"] = 3] = "ForcePage";
  Event[Event["UpdatePages"] = 4] = "UpdatePages";
  return Event;
}(Event || {});
var reducer = function reducer(state, action) {
  switch (action.event) {
    case Event.Auto:
      return _objectSpread(_objectSpread({}, state), {}, {
        paginationState: PaginationState.Auto,
        currentPage: state.currentPage === state.totalPages ? 1 : state.currentPage + 1
      });
    case Event.Next:
      return _objectSpread(_objectSpread({}, state), {}, {
        paginationState: PaginationState.Idle,
        currentPage: state.currentPage === state.totalPages ? 1 : state.currentPage + 1
      });
    case Event.Prev:
      return _objectSpread(_objectSpread({}, state), {}, {
        paginationState: PaginationState.Idle,
        currentPage: state.currentPage === 1 ? state.totalPages : state.currentPage - 1
      });
    case Event.UpdatePages:
      return _objectSpread(_objectSpread({}, state), {}, {
        totalPages: action.payload.totalPages,
        currentPage: 1
      });
    case Event.ForcePage:
      return _objectSpread(_objectSpread({}, state), {}, {
        paginationState: PaginationState.Idle,
        currentPage: action.payload.currentPage
      });
    default:
      return state;
  }
};
function useCarousel(totalPages, config) {
  var timer = (config === null || config === void 0 ? void 0 : config.timer) || 5000;
  var delayStart = (config === null || config === void 0 ? void 0 : config.delayStart) || timer;
  var _useReducer = useReducer(reducer, {
      currentPage: 1,
      paginationState: PaginationState.Idle,
      totalPages: 0
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    setState = _useReducer2[1];
  var isBrowserIdle = useBrowserIdle();
  useInterval(function () {
    requestAnimationFrame(function () {
      setState({
        event: Event.Auto
      });
    });
  }, isBrowserIdle && totalPages > 1 && state.paginationState === PaginationState.Auto ? timer : null);
  useEffect(function () {
    var timeout;
    if (isBrowserIdle && state.paginationState === PaginationState.Idle) {
      timeout = setTimeout(function () {
        return setState({
          event: Event.Auto
        });
      }, delayStart || timer);
    } else if (timeout) {
      // If for some reason Idle changes to Auto, cancel the timeout if it started
      clearTimeout(timeout);
      timeout = undefined;
    }
    return function () {
      if (timeout) clearTimeout(timeout);
    };
  }, [isBrowserIdle, delayStart, timer, state.paginationState]);
  useEffect(function () {
    return setState({
      event: Event.UpdatePages,
      payload: {
        totalPages: totalPages
      }
    });
  }, [totalPages]);
  var onNext = function onNext() {
    return setState({
      event: Event.Next
    });
  };
  var onPrev = function onPrev() {
    return setState({
      event: Event.Prev
    });
  };
  var onPageChange = function onPageChange(index) {
    setState({
      event: Event.ForcePage,
      payload: {
        currentPage: index
      }
    });
  };
  return {
    currentPage: state.currentPage,
    onNext: onNext,
    onPrev: onPrev,
    onPageChange: onPageChange
  };
}
export default useCarousel;